// extracted by mini-css-extract-plugin
module.exports = {"wrap":"wrap-3ejDgEYS fl clearfix","list":"list-SOUeLXZ1","qqg":"qqg-1xxXTjPv"};